import { forEach } from 'jszip';
import { IDate, IYearMonth } from '../date';
import { IBusiness } from './businessBase';
import { DateService } from '../services/dateService';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * 標準在庫指数
 * @property min - 最小値
 * @property max - 最大値
 * @property option - オプション
 * @property option.unit - 単位
 */
type StdInventoryIndex = {
  min: number;
  max: number;
  option: {
    /* これはStdindexInfoのために必要なだけで、min,maxは計算上そのままの値 */
    unit: string; // TODO ValueObjectにする
  };
};

/**
 * 標準在庫指数(単体)
 */
interface StdIndexInfo {
  name: string;
  min: number;
  max: number;
  unit: string;
}

/**
 * シミュレーション用(?)マイナス在庫の情報
 * @property startDate - 開始日
 * @property date - 日付
 * @property value - 減算する値
 */
interface MinusInventory {
  startDate: IDate | undefined;
  date: IDate;
  value: number;
}

/**
 * 在庫に関する情報
 * @property businessId - 取引ID
 * @property inventory - 当日在庫
 * @property mvpInventory - 当日在庫(mvp用、転写に使う)
 * @property stdInventoryIndices - 標準在庫指数
 */
interface IInventory {
  businessId: string;
  inventory: number | undefined;
  mvpInventory: IMvpInventory[] | undefined;
  stdInventoryIndices: { [key: string]: StdInventoryIndex } | undefined;
}

/**
 * MVP用の在庫情報
 * @property amount - 数量
 */
interface IMvpInventory extends IYearMonth {
  amount: number;
}

/**
 * オブジェクトが在庫情報かどうかを明確にする
 * @param value - 指定された在庫オブジェクト
 * @returns IInventoryとして定義されたオブジェクト
 */
function isIInventory(value: object): value is IInventory {
  /*TODO: IInventoryが持つべきものを明確にする */
  return true;
}

const inventoryProperties = [
  // aggregator.tsで利用する
  'businessId',
  'inventory',
  'mvpInventory',
  'stdInventoryIndices',
] as const;

const emptyInventory: StdInventoryIndex = {
  min: 0,
  max: 0,
  option: {
    unit: '',
  },
};

export type { IInventory, MinusInventory, StdInventoryIndex, IMvpInventory, StdIndexInfo };
export { inventoryProperties, isIInventory, emptyInventory };
